import { createFileRoute } from '@tanstack/react-router'

import { JellyIcon } from '@/components/icons'
import { AppButton } from '@/components/shared'
import { AppLink as Link } from '@/components/shell'
import { RatingRow, SelectableGrid } from '@/components/spravce/kontrola'
import { DELIVERY, ITEMS, RATINGS } from '@/mocks/spravce/kontrola'

export const Route = createFileRoute('/spravce/kontrola/$client')({
  head: () => ({ meta: [{ title: 'Kontrola podkladů · Aplikace Bitez' }] }),
  component: SpravceKontrola,
})

function SpravceKontrola() {
  const selectedCount = ITEMS.filter((item) => item.selected).length

  return (
    <div className="px-4 pt-4 pb-2">
      <Link
        href="/spravce/prehled"
        className="-ml-1 flex w-fit items-center gap-1.5 rounded-full px-1 py-1 text-[10px] font-bold tracking-widest text-ink/40 uppercase transition-colors duration-150 hover:text-ink/70"
      >
        <JellyIcon name="arrow-left" className="size-3" />
        Přehled
      </Link>

      <header className="mt-3 flex items-center gap-3">
        <img
          src={DELIVERY.avatar}
          alt=""
          width={150}
          height={150}
          className="size-12 shrink-0 rounded-2xl object-cover"
        />
        <div className="min-w-0">
          <h1 className="font-display truncate text-2xl leading-[0.9] uppercase">
            {DELIVERY.venue}
          </h1>
          <p className="text-xs font-semibold text-ink/50">{DELIVERY.from}</p>
        </div>
      </header>

      <section className="animate-rise-up mt-5">
        <div className="flex items-baseline justify-between gap-2">
          <p className="text-[10px] font-bold tracking-widest text-ink/40 uppercase">
            Z čeho stavíte
          </p>
          <p className="rounded-full bg-brand px-2.5 py-0.5 text-[10px] font-bold text-white">
            {selectedCount} vybráno
          </p>
        </div>
        <div className="mt-3">
          <SelectableGrid items={ITEMS} />
        </div>
      </section>

      <section className="animate-rise-up mt-6" style={{ animationDelay: '90ms' }}>
        <p className="text-[10px] font-bold tracking-widest text-ink/40 uppercase">
          Ohodnoťte podklady od Tomáše
        </p>
        <div className="mt-3 space-y-3 rounded-3xl bg-white p-4 shadow-sm">
          {RATINGS.map((rating) => (
            <RatingRow key={rating.label} label={rating.label} value={rating.value} />
          ))}
          {/* The third direction of spec §9, and the only one scored per
              dimension: she is judging work, not courtesy. Same promise as the
              other two ratings — he sees stars, never words (decision C3). */}
          <p className="border-t border-dashed border-ink/10 pt-3 text-[10px] leading-relaxed font-semibold text-ink/45">
            Propíše se do jeho reputace. Uvidí jen hvězdičky.
          </p>
        </div>
      </section>

      <div className="sticky bottom-0 -mx-4 bg-gradient-to-t from-cream via-cream/95 to-transparent px-4 pt-8 pb-3">
        <AppButton className="w-full">
          <JellyIcon name="check" variant="fill" className="size-3.5" />
          Potvrdit výběr ({selectedCount}) a hodnocení
        </AppButton>
        {/* Her pick gates nothing (owner, 2026-08-19) — the client already has
            every uploaded shot in their library. This is her own shortlist for
            the builder, and saying so keeps her out of the censor's chair. */}
        <p className="mt-2 text-center text-[10px] text-ink/45">
          Klient má v knihovně všechno. Tohle je váš výběr pro příspěvky.
        </p>
      </div>
    </div>
  )
}
